import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Get_In_Touch.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faEnvelope,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";
import Send_Msg_Modal from "./send-msg-modal/Send_Msg_Modal";
import { CreateContact_Us } from "../../../features/admin/contactus/contact/Slice";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";
import Form from "react-bootstrap/Form";
import { Context } from "../../../utils/context";

const Get_In_Touch = ({ all_app_setup }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userdata } = useContext(Context);

  const {
    control,
    register,
    handleSubmit,
    setValue,
    getValues,
    reset,
    watch,
    formState: { errors },
  } = useForm();

  const [showModal, setShowModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [apiError, setApiError] = useState("");
  useEffect(() => {
    if (showModal) {
      const timer = setTimeout(() => {
        setShowModal(false);
        navigate("/");
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [showModal]);

  const [formData, setFormData] = useState({
    fname: "",
    lname: "",
    phone: "",
    email: "",
    message: "",
  });
  // const [formData, setFormData] = useState({
  //   fname: "",
  //   lname: "",
  //   phone: "",
  //   email: "",
  //   message: "",
  // });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const onSubmit = async (data) => {
    const payload = {
      name: `${data.fname} ${data.lname}`,
      mobile_number: data.mobile_number,
      email: data.email,
      message: data.message,
      type: userdata?.type || "guest",
    };

    try {
      setIsSubmitting(true);
      setApiError("");

      const res = await dispatch(CreateContact_Us(payload)).unwrap();

      if (res?.success) {
        setShowModal(true);
        reset();
      } else {
        setApiError(res?.message || "Something went wrong");
      }
    } catch (err) {
      console.log("ERROR:", err);

      const errorMessage =
        err?.message ||
        err?.error ||
        err?.data?.message ||
        (typeof err === "string" ? err : null) ||
        "Something went wrong";

      setApiError(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="get-touch-wrapper">
      <div className="container">
        <div className="get-touch-card">
          <div className="get-touch-left">
            <h2>GET IN TOUCH</h2>

            <div className="get-in-touch-data">
              <p>
                Have questions or need assistance? Our team is here to help you.
                Get in touch and we’ll respond as soon as possible.
              </p>
            </div>
            <div className="contact-item">
              <span className="icon">
                <FontAwesomeIcon icon={faPhone} />
              </span>
              {/* <span>+91 9954878569</span> */}
              <span>{all_app_setup?.contact_no}</span>
            </div>
            <div className="contact-item">
              <span className="icon">
                <FontAwesomeIcon icon={faEnvelope} />
              </span>
              <span>{all_app_setup?.email}</span>
            </div>
            <div className="contact-item">
              <span className="icon">
                <FontAwesomeIcon icon={faLocationDot} />
              </span>
              {/* <span>Bangalore, India</span> */}
              <span>{all_app_setup?.address}</span>
            </div>
          </div>

          <form className="get-touch-right" onSubmit={handleSubmit(onSubmit)}>
            <div className="form-row">
              <div className="input-group">
                <Form.Control
                  type="text"
                  placeholder=" "
                  {...register("fname", {
                    required: "First name is required",
                  })}
                  className={classNames({
                    "is-invalid": errors?.fname,
                  })}
                />
                {errors?.fname && (
                  <span className="invalid-feedback d-block mb-4">
                    {errors.fname.message}
                  </span>
                )}
                <label htmlFor="fname">First Name</label>
              </div>
              <div className="input-group">
                <Form.Control
                  type="text"
                  placeholder=" "
                  {...register("lname", {
                    required: "Last name is required",
                  })}
                  className={classNames({
                    "is-invalid": errors?.lname,
                  })}
                />
                {errors?.lname && (
                  <span className="invalid-feedback d-block mb-4">
                    {errors.lname.message}
                  </span>
                )}
                <label htmlFor="lname">Last Name</label>
              </div>
            </div>

            <div className="form-row">
              <div className="input-group">
                <Form.Control
                  type="text"
                  placeholder=" "
                  maxLength={10}
                  {...register("mobile_number", {
                    required: "Phone number is required",
                    pattern: {
                      value: /^[0-9]{10}$/,
                      message: "Enter valid 10 digit phone number",
                    },
                  })}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/\D/g, "");
                  }}
                  className={classNames({
                    "is-invalid": errors?.mobile_number,
                  })}
                />

                {errors?.mobile_number && (
                  <span className="invalid-feedback d-block mb-4">
                    {errors.mobile_number.message}
                  </span>
                )}

                <label htmlFor="phone">Phone No.</label>
              </div>
              <div className="input-group">
                <Form.Control
                  type="email"
                  placeholder=" "
                  {...register("email", {
                    required: "Email is required",
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Invalid email address",
                    },
                  })}
                  className={classNames({
                    "is-invalid": errors?.email,
                  })}
                />
                {errors?.email && (
                  <span className="invalid-feedback d-block mb-4">
                    {errors.email.message}
                  </span>
                )}
                <label htmlFor="email">Email Id</label>
              </div>
            </div>
            <div className="input-group">
              <Form.Control
                as="textarea"
                rows={4}
                placeholder=" "
                {...register("message", {
                  required: "Message is required",
                })}
                className={classNames({
                  "is-invalid": errors?.message,
                })}
              />
              {errors?.message && (
                <span className="invalid-feedback d-block mb-4">
                  {errors.message.message}
                </span>
              )}
              <label htmlFor="message">Message</label>
            </div>

            {/* ✅ API ERROR HERE */}
            {apiError && (
              <div className="text-danger mt-2 text-center">{apiError}</div>
            )}

            <div className="btn-container">
              <button
                type="submit"
                className="send-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Sending..." : "Send Message"}
              </button>
            </div>
            {/* 
            <div className="input-group">
              <Form.Control
                as="textarea"
                rows={4}
                placeholder=" "
                {...register("message", {
                  required: "Message is required",
                })}
                className={classNames({
                  "is-invalid": errors?.message,
                })}
              />
              {errors?.message && (
                <span className="invalid-feedback d-block mb-4">
                  {errors.message.message}
                </span>
              )}
              <label htmlFor="message">Message</label>
            </div>

            <div className="btn-container">
              <button
                type="submit"
                className="send-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Sending..." : "Send Message"}
              </button>
            </div> */}
          </form>
        </div>
      </div>

      {/* MODAL INTEGRATION */}
      <Send_Msg_Modal
        showRequestSent={showModal} // Prop name from your Modal component
        handleRequestSendClose={() => setShowModal(false)} // Prop name from your Modal component
      />
    </div>
  );
};

export default Get_In_Touch;
